<template>
  <div>
    <the-nav-bar :title="$t('newSettings.todamoonTitle')"  ref="nav" />
    <div class="body-wrapper">
      <div
        v-for="i in 4"
        :key="i"
        :class="['list-item', 'row-align-center']"
      >
        
        <div class="text-box row">
          <div class="index">{{ `${i}` }}. </div>
          <div>
            <h3 class="title" v-html="$t(`newSettings.todamoonDetails[${i - 1}].title`)"></h3>
            <p class="text" v-html="$t(`newSettings.todamoonDetails[${i - 1}].content`)"></p>
          </div>
        </div>
      </div>
      <div class="img-box">
          <img :src="require(`./crypto_flowers.png`)" alt="" class="img" />
        </div>
        <md-button type="primary" @click="goBack" class="popup-footer">
          <span>{{ $t('common.known') }}</span>
        </md-button>
    </div>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import { Field, FieldItem,Button} from 'mand-mobile';
export default {
  components: {
    TheNavBar,
    [Button.name]: Button,
    [FieldItem.name]: FieldItem,
    [Field.name]: Field,
  },
  computed: {

  },
  methods: {
    goBack() {
      this.$refs.nav && this.$refs.nav.goBack();
    },
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  padding-bottom: 40vw;

  >>> .strong {
    color: color-primary;
  }
}

.list-item {
  margin: 5.33vw 5.33vw;

  &.reverse {
    flex-direction: row-reverse;

    .text-box {
      padding-right: 2.13vw;
      padding-left: 0;
    }
  }

  .img {
    width: 28.27vw;
  }

  .text-box {
    padding-left: 2.13vw;
    padding-right: 0;
  }

  .index {
    margin-right: 2.13vw;
    font-size: 4.27vw;
    line-height: 5.33vw;
    font-weight: bold;
  }

  .title {
    margin: 0;
    font-size: 4.27vw;
    line-height: 5.33vw;
  }

  .text {
    font-size: 3.2vw;
    line-height: 4.27vw;
    color: color-text-caption;

    >>> a {
      text-decoration: none;
      color: color-primary;
    }
  }
}

.division {
  height: 5.33vw;
  background: #F8FBFC;
}

.field {
  margin: 0;
  padding: 0;

  .icon {
    width: 4.8vw;
    height: 4.8vw;
    color: color-text-base;
  }

  >>> {
    .md-field-item-content {
      padding: 0 5.07vw;
      min-height: 17.07vw;

      &:before {
        display: none;
      }
    }
  }
}
.img-box
align-content center
.popup-footer {
    margin: 0 auto;
    width: 60vw;
}
</style>
